/**
* Created by kongwm.kong on 2017/7/25.
*/
<template>
    <div class="layout_n">
        <div class="net_management_wrap">
            <div class="submenu_wrap">
                <div :class="{'menu-item':true,'active':item1}" @click="joined">已加入公司</div>
                <div :class="{'menu-item':true, 'active':item2}" @click="joining">待加入公司</div>
            </div>
            <company-table :isJoined="isJoined" ></company-table>
        </div>
    </div>

</template>
<script>
    import companyTable from './company_table';
    export default {
        data(){
            return{
                item1: true,
                item2: false
            }
        },
        components:{
            companyTable
        },
        computed: {
            isJoined(){
                if(this.item1){
                    return 1;
                }else {
                    return 2;
                }

            }
        },
        created(){
            this.getItem();
        },
        methods: {
            getItem(){
              let item = this.$route.query.item;
              if(item==2){
                  this.joining();
              }
            },
            joined(e){
                this.item2 = false;
                this.item1 = true;
            },
            joining(e){
                this.item1 = false;
                this.item2 = true;
            }
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
    @import "../../assets/css/common/center";
    .layout_n{
        @include mainMar;
        .net_management_wrap{
            padding: 1px 38px 230px;
            @include bgff;
            .search_wrap{
                .add_product{
                    width:168px;
                    float: left;
                    .btn{
                        color:#fff;
                        background: $btn_408;
                        height:46px;
                        width:168px;
                        font-size: 18px;
                        letter-spacing: -0.43px;
                        line-height: 46px;
                        span{
                            display: inline-block;
                            width:20px;
                            height:20px;
                            border-radius: 50%;
                            background: #fff;
                            color:$btn_408;
                            font-weight: bold;
                            vertical-align: middle;
                            line-height: 1;
                            text-indent: -1px;
                            margin-left:5px;
                        }
                    }
                }
                .search{
                    margin-top:4px;
                    input{
                        border: 1px solid $border_bfb;
                        height:40px;
                        width:309px;
                        padding:10px 0;
                        text-indent: 20px;
                        line-height: 16px;
                        font-size:16px;
                        vertical-align: middle;
                    }
                    .sear_btn{
                        width:40px;
                        height:40px;
                        background: url(../../assets/img/common/search.png) center center no-repeat;
                        background-color: $btn_408;
                        vertical-align: middle;
                        margin-left: -4px;
                    }
                }
            }
            .submenu_wrap{
                margin-top:50px;
                @include subMenu;
                margin-bottom:50px;
            }

        }
    }
</style>


// WEBPACK FOOTER //
// src/views/company/index.vue